<div class="row">
    <div class="col-12">
      <div class="content-header">Channel Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
                      <h4 class="card-title">Basic</h4>
                  </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md">
                  <form [formGroup]="channelForm">
                    <fieldset class="form-group">
                      <label for="name">Name</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="name" [(ngModel)]="channel.name"
                        id="name"
                        placeholder="Enter name"
                        [ngClass]="{
                          'is-invalid': channelFormSubmitted && rf.name.invalid,
                          'is-valid': channelFormSubmitted && !rf.name.invalid
                        }"
                        required
                      />
                      <div
                        *ngIf="
                          rf.name.touched &&
                          (rf.name.invalid || rf.name.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> Name is
                        required
                      </div>
                    </fieldset>
                    <fieldset class="form-group">
                        <label for="name">Category</label>
                      <ng-select
                        [items]="channelList"
                        bindLabel="displayname"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        placeholder="Select Category"
                        [(ngModel)]="selectedCat"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getCategoryId($event)"
                      >
                      </ng-select>
                    </fieldset>
                    <fieldset class="form-group">
                      <label class="form-control-label" for="date">Technology</label>
                      <ng-select [items]="technology_List" bindLabel="displayname" bindValue="_id"
                        placeholder="Select Technology" [(ngModel)]="selectedTechnology"
                        [ngModelOptions]="{ standalone: true }" (change)="getTechnologyId($event)">
                      </ng-select>
                    </fieldset>
                  </form>
                </div>
                <div class="col-md">
                  <form [formGroup]="channelForm">
                    <fieldset class="form-group">
                      <label for="notes">notes</label>
                      <textarea
                        formControlName="notes" [(ngModel)]="channel.notes"
                        id="hidden-label-form-6"
                        rows="1"
                        class="form-control"
                        name="comment2"
                        placeholder="Enter notes"
                      ></textarea>
                    </fieldset>
                    <fieldset class="form-group">
                      <label for="admin_notes">admin notes</label>
                      <textarea
                        formControlName="admin_notes" [(ngModel)]="channel.admin_notes"
                        id="hidden-label-form-6"
                        rows="4"
                        class="form-control"
                        name="comment2"
                        placeholder="Enter admin notes"
                      ></textarea>
                    </fieldset>
                    <div
                      class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                    >
                      <button *ngIf="currentUrl =='add'"
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                        (click)="submit()"
                      >
                        Submit
                      </button>
                      <button *ngIf="currentUrl =='edit'"
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                        (click)="update()"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        class="btn btn-secondary"
                       (click)="back()"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
